module.exports = __webpack_public_path__ + "img/newbook.0ed7842e.svg";